import { render, staticRenderFns } from "./LinkedInEmploymentListItem.vue?vue&type=template&id=6975fb5a&scoped=true&"
import script from "./LinkedInEmploymentListItem.vue?vue&type=script&lang=ts&"
export * from "./LinkedInEmploymentListItem.vue?vue&type=script&lang=ts&"
import style0 from "./LinkedInEmploymentListItem.vue?vue&type=style&index=0&id=6975fb5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6975fb5a",
  null
  
)

/* custom blocks */
import block0 from "./LinkedInEmploymentListItem.json?vue&type=custom&index=0&blockType=i18n&issuerPath=D%3A%5Ca%5C1%5Cs%5Ccomponents%5Ctalent%5CLinkedInEmploymentListItem.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
